<template>
	<div class="shortcuts" ref="shortcuts" >
		<div class="shortcut" :class="{negative: shortcut.value < 0}" v-for="(shortcut, index) in shortcuts" :key="index" @click="$emit('shortcut', shortcut.value)">
			<p>{{ shortcut.displayValue }}</p>
		</div>
	</div>
</template>

<script>

export default {
	name: "BottomNumberEditorShortcuts",
	emits: ["shortcut"],
	computed: {
		shortcuts() {
			let shortcuts = [5,10,20,30,50];
			let result = [];

			if(!this.noHundredPercent) {
				shortcuts.push(100);
			}

			shortcuts.forEach((shortcut) => {
				if(!this.onlyDecrement) {
					result.push({
						value: shortcut,
						displayValue: "+" + shortcut+"%"
					});
				}
				result.unshift({
					value: -shortcut,
					displayValue: "-" + shortcut+"%"
				});
			});
			return result;
		}
	},
	props: {
		onlyDecrement: {
			type: Boolean,
			default: false,
		},
		noHundredPercent: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
	},
	mounted() {
		this.$nextTick(() => {
			if(this.onlyDecrement) {
				this.$refs.shortcuts.scrollLeft = this.$refs.shortcuts.scrollWidth - this.$refs.shortcuts.clientWidth;
			} else {
				this.$refs.shortcuts.scrollLeft = (this.$refs.shortcuts.scrollWidth - this.$refs.shortcuts.clientWidth) / 2;
			}
		});
	},
}
</script>

<style scoped lang="scss">
.shortcuts {
	width: 100%;
	display: flex;
	flex-direction: row;
	background-color: var(--color-bg-primary-1);
	border-top: 1px solid var(--color-alpha-4);
	border-bottom: 1px solid var(--color-alpha-4);
	border-radius: 13px;
	overflow-x: auto;
	gap: 8px;
	padding: 8px;
	@include hideScrollbar();

	.shortcut {
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 30px;
		cursor: pointer;
		padding: 6px 10px;
		border: 1px solid $primary;
		transition: background-color 0.3s $transition;
		border-radius: 13px;
		min-width: 60px;
		background-color: var(--color-fill-positive);

		&:hover {
			background-color: var(--color-fill-positive-hover);
		}

		&.negative {
			background-color: var(--color-fill-negative);

			&:hover {
				background-color: var(--color-fill-negative-hover);
			}

		}

		p {
			font-size: 14px;
			color: $primary;
		}

	}
}
</style>